// Role hierarchy — must mirror config/packages/security.yaml in the backend.
//
// Operational tree: Admin > Manager > (CSC | HR) > Staff > User.
// CSC (client care pages) and HR (People pages) are sibling branches under
// manager, so each sees only its own section.
// Board is a parallel branch that only inherits ROLE_USER (own profile),
// keeping board members out of operational pages.
export const role_hierarchy: { [key: string]: string | string[] } = {
    ROLE_ADMIN: ['ROLE_MANAGER'],
    ROLE_MANAGER: ['ROLE_CSC', 'ROLE_HR'],
    ROLE_CSC: ['ROLE_STAFF'],
    ROLE_HR: ['ROLE_STAFF'],
    ROLE_STAFF: ['ROLE_USER'],
    ROLE_BOARD: ['ROLE_USER'],
    ROLE_SUPER_ADMIN: ['ROLE_ADMIN'],
};

// Human-readable labels for the role selector in the user admin UI.
export const role_labels: { [key: string]: string } = {
    ROLE_USER: 'Staff (own profile only)',
    ROLE_STAFF: 'Staff',
    ROLE_BOARD: 'Board',
    ROLE_CSC: 'Client Services',
    ROLE_HR: 'HR',
    ROLE_MANAGER: 'Management',
    ROLE_ADMIN: 'Admin',
};
